import { FC } from 'react';

import { Badge, CalendarDays, Crown, LucideIcon, Shield } from 'lucide-react';

import { FilterGlyphIcon } from './FilterGlyphIcon';
import { cn } from '../../../utils';

interface Props {
    readonly iconKey: string;
    readonly className?: string;
}

const MANA_GLYPHS: Record<string, string> = {
    mtg_type_artifact: 'ms-artifact',
    mtg_type_battle: 'ms-battle',
    mtg_type_conspiracy: 'ms-conspiracy',
    mtg_type_creature: 'ms-creature',
    mtg_type_dungeon: 'ms-dungeon',
    mtg_type_enchantment: 'ms-enchantment',
    mtg_type_instant: 'ms-instant',
    mtg_type_kindred: 'ms-tribal',
    mtg_type_land: 'ms-land',
    mtg_type_phenomenon: 'ms-phenomenon',
    mtg_type_plane: 'ms-plane',
    mtg_type_planeswalker: 'ms-planeswalker',
    mtg_type_scheme: 'ms-scheme',
    mtg_type_sorcery: 'ms-sorcery',
    mtg_type_token: 'ms-token',
    mtg_type_vanguard: 'ms-vanguard',
};

const GLYPH_ICONS: Record<string, LucideIcon> = {
    mtg_type_boss: Crown,
    mtg_type_emblem: Badge,
    mtg_type_event: CalendarDays,
    mtg_type_hero: Shield,
};

export const MagicTypeOptionIcon: FC<Props> = ({ iconKey, className }) => {
    const glyphIcon = GLYPH_ICONS[iconKey];
    if (glyphIcon) {
        return (
            <FilterGlyphIcon
                icon={glyphIcon}
                className={className}
                containerClassName="border-violet-500/40 bg-violet-500/10 text-violet-700 dark:text-violet-300"
            />
        );
    }

    const glyphClassName = MANA_GLYPHS[iconKey];
    if (!glyphClassName) return null;

    return (
        <span
            aria-hidden="true"
            className={cn(
                'inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full border bg-muted/50 text-foreground',
                ['mtg_type_land', 'mtg_type_token'].includes(iconKey) &&
                    'border-amber-500/60 bg-amber-500/10 text-amber-600',
                className,
            )}
        >
            <i className={cn('ms ms-fw text-base', glyphClassName)} />
        </span>
    );
};
